import { calculateLocatinVars } from '../../../libs/browser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonDescription from '../../../components/CommonDescription';
import CommonIconButton from '../../../components/CommonIconButton';
import CommonPageTitle from '../../../components/CommonPageTitle';
import Context from '../../../provider';
import ErrorPage from '../../../pages/ErrorPage';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useContext, useEffect, useState } from 'react';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileJoinInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, lang, me, dispatch } = useContext(Context);

  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: locationVars.join('/') });
      setData(page);
      setLoaded(true);
    } catch (error) {
      setPageNotFound(true);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) fetchData();
  }, [init]);

  // This page only allow logged in user
  useEffect(() => {
    if (init && me) {
      if (me.status === 'activated') {
        navigate(`${config.basename}`);
      }
    }
  }, [init, me]);

  const getSectionStyle = (section) => {
    const style = {};
    if (section?.color_background_class) style.backgroundColor = section.color_background_class;
    if (section?.color_foreground_class) style.color = section.color_foreground_class;
    if (section?.background_texture) style.backgroundImage = `url(${section.background_texture})`;
    return style;
  };

  return (
    (
      <>
        {pageNotFound && <ErrorPage type="notFound" />}
        {
          !pageNotFound &&
          <div className='mobile-join-info-page'>
            <BackCloseBarComponent isBack={true} />

            <div className="y-overflow info-container">
              {data?.title?.[lang] && <CommonPageTitle title={data?.title?.[lang]} />}
              {loaded && (data?.sections ??[]).map((section) => {
                return (
                  <section className={ section.container_behavior ?? null } key={section.anchor} style={getSectionStyle(section)}>
                    <CommonDescription
                      title={section.hide_title ? null : section?.title?.[lang]}
                      data={section?.content?.[lang]}
                    />
                  </section>
                );
              })}
              <CommonIconButton
                text={t('common.tier-benefits')}
                alignItems = "unset"
                btnBackgroundColor= "#ffffff"
                btnColor= "#004899"
                border = "0.0625rem solid #004899"
                padding = "0.375rem 1.75rem"
                btnPadding = "0rem"
                btnWidth= { lang === 'en' ? "13rem" : '9rem'}
                onClick={() => {
                  navigate(`${config.basename}`, {
                    state: {
                        toClass: '.benefits-section-cont'
                    }
                });
                }}
              />
              <CommonIconButton
                text={t('join-info.join-btn')}
                endIcon= {<KeyboardArrowRightIcon />}
                alignItems = "unset"
                backgroundColor= "#004899"
                btnColor= "#ffffff"
                btnWidth= { lang === 'en' ? "13rem" : '9rem'}
                padding = "0.375rem 1.75rem"
                btnPadding = "0rem"
                onClick={() => {
                  navigate(`${config.basename}login`);
                }}
              />
            </div>
          </div>
        }
      </>
    )
  );
}